<template>
  <div>
    <el-dialog title="意见反馈" :visible.sync="suggestVisible" width="800px">
      <el-form :model="form" ref="suggestForm">
        <el-form-item label="问题类型" :required="true" label-width="120px">
          <el-select v-model="form.type" placeholder="请选择问题类型">
            <el-option label="续费" value="续费"></el-option>
            <el-option label="产品功能" value="产品功能"></el-option>
            <el-option label="售后问题" value="售后问题"></el-option>
            <el-option label="产品建议" value="产品建议"></el-option>
            <el-option label="会员反馈" value="会员反馈"></el-option>
            <el-option label="商品店铺删除" value="商品店铺删除"></el-option>
            <el-option label="平台风险类" value="平台风险类"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述" :required="true" label-width="120px">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="相关图片" label-width="120px">
          <el-upload
            :action="action"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="maxMessage"
            :on-success="handleSuccess"
            ref="suggestImg"
            :limit="4">
            <i class="el-icon-plus"></i>
          </el-upload>
          <span style="color: #999;font-size: 12px;">单张图片大小不超过2M，最多4张</span>
        </el-form-item>
        <el-form-item label="联系方式" label-width="120px">
          <el-input v-model="form.email" placeholder="请务必输入邮箱地址，后续将通过邮箱与您联系"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="saveSuggest">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>

<script>
  import { addSuggest } from "@/api/nav.js";
  import { upload } from "@/api/upload.js";
  export default {
    name: 'suggest',
    data() {
      return {
        form: {
          imageUrls: []
        },
        dialogImageUrl: '',
        dialogVisible: false,
        loading: false,
        suggestVisible: false,
        action: upload,
      }
    },
    methods: {
      async saveSuggest(){
        const response = await addSuggest(this.form);
        const res = response.data;
        if (res.code === "200") {
          this.$message({
            message: "添加成功！",
            type: "success",
          });
          this.suggestVisible = false

          this.$refs['suggestImg'].clearFiles()
          this.form = {imageUrls: []}
        }else{
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      },
      show(){
        this.suggestVisible = true
      },
      maxMessage(files, fileList){
        this.$message({
          message: "最多只能添加4张图片",
          type: "error",
        })
      },
      handleRemove(file, fileList) {
        this.form.imageUrls.forEach((item,index,arr) => {
          if(item === file.response.data.url){
            this.form.imageUrls.splice(index,1);
          }
        });
      },
      handleSuccess(response, file, fileList){
        this.form.imageUrls.push(response.data.url);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      cancle(){
        this.suggestVisible = false
      }
    }
  }
</script>

<style scoped lang="scss">
  >>>.el-button--primary:hover {
    background: #004097;
    border-color: #004097;
    color: #FFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/suggest.vue